module.exports = __webpack_public_path__ + "static/media/4.0c5c3cc7.jpg";